import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { NoticeItem } from '@/types/notice'

/** `GET /app/notice/list`（匿名可看，可带登录 token）。 */
export function getNoticeList(): Promise<ApiResponse<NoticeItem[]>> {
  return http.get<ApiResponse<NoticeItem[]>>('/app/notice/list').then((r) => r.data)
}

/** `POST /app/notice/read` 批量已读（575758b）。
 *  幂等：后端对不可见公告静默忽略；data 恒为 null。
 *  失败时**不阻塞** UI，store 层会静默回滚。
 */
export function markNoticeRead(ids: number[]): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/notice/read', { ids }).then((r) => r.data)
}

/** `GET /app/notice/unread-count` 未读公告数（575758b）。
 *  返回**裸数字**（与 `/app/msg/unread-count` 同风格但独立展示）。
 *  未登录调用会触发 `40101` 拦截器（不需登录态但匿名调用无意义）。
 */
export function getNoticeUnreadCount(): Promise<ApiResponse<number>> {
  return http.get<ApiResponse<number>>('/app/notice/unread-count').then((r) => r.data)
}
